import { Variables } from '../../../styles/variables'
import styled from "styled-components";

interface Props extends React.ComponentPropsWithoutRef<'div'> {
    countInitiatives: number
}

export const Container = styled.div<Props>`
position: relative;
min-height: calc(100vh - 171px);
padding-bottom: 83px;

.ui {
    &.form {
        position: unset;

        .networks-layout {
            display: grid;
            grid-template-columns: minmax(0, 1fr) 320px;
            gap: 24px;
            align-items: start;
        }

        .networks-main {
            min-width: 0;
        }

        .section-intro {
            margin-bottom: 20px;

            h3 {
                margin: 0 0 6px;
                font-size: 18px;
                font-weight: 600;
                color: #1C1B1F;
            }

            p {
                margin: 0;
                color: #516274;
                font-size: 14px;
                line-height: 1.45;
            }
        }

        .field {
            margin-bottom: 14px;

            &.dropdown-initiatives {
                .multiple {
                    &.dropdown {
                        &::after {
                            content: '${props => props.countInitiatives}';
                            display: ${props => props.countInitiatives > 0 ? 'block' : 'none'};
                            width: 30px;
                            text-align: center;
                            position: absolute;
                            background: ${Variables.yellow};
                            color: ${Variables.gray};
                            padding: 5px;
                            border-radius: 4px;
                            font-size: 14px;
                            font-weight: 600;
                            right: 42px;
                        }
                    }
                }
            }
        }

        .received-section {
            margin-top: 28px;
            padding: 20px;
            border: 1px solid #D9DEE5;
            border-radius: 16px;
            background: #FFF;

            .section-head {
                display: flex;
                gap: 12px;
                align-items: flex-start;
                margin-bottom: 16px;

                .section-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 12px;
                    background: rgba(244, 198, 0, 0.22);
                    color: #516274;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }

                h3 {
                    margin: 0 0 4px;
                    font-size: 16px;
                    font-weight: 600;
                    color: #1C1B1F;
                }

                p {
                    margin: 0;
                    font-size: 13px;
                    line-height: 1.4;
                    color: #516274;
                }
            }

            .partnership-group {
                margin-bottom: 18px;

                &:last-child {
                    margin-bottom: 0;
                }

                h4 {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin: 0 0 10px;
                    font-size: 13px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.04em;
                    color: #516274;

                    span {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        min-width: 20px;
                        height: 20px;
                        padding: 0 6px;
                        border-radius: 999px;
                        background: ${Variables.yellow};
                        color: ${Variables.gray};
                        font-size: 11px;
                    }
                }
            }

            .received-empty {
                padding: 14px 16px;
                border-radius: 12px;
                background: #F7F8FA;
                color: #516274;
                font-size: 13px;
                line-height: 1.45;
            }

            .received-card {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 12px;
                padding: 12px 14px;
                border-radius: 12px;
                background: #F7F8FA;
                margin-bottom: 10px;

                &:last-child {
                    margin-bottom: 0;
                }

                &.pending {
                    background: rgba(244, 198, 0, 0.12);
                }

                &.accepted {
                    background: rgba(0, 103, 104, 0.08);
                }

                .received-main {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    min-width: 0;

                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                        object-fit: cover;
                        flex-shrink: 0;
                        background: #FFF;
                    }
                }

                .received-info {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    min-width: 0;

                    strong {
                        font-size: 14px;
                        color: #1C1B1F;
                        word-break: break-word;
                    }

                    .meta {
                        font-size: 12px;
                        color: #79747E;
                    }
                }

                .badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    width: fit-content;
                    padding: 2px 8px;
                    border-radius: 999px;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 0.02em;

                    &.pending {
                        background: rgba(244, 198, 0, 0.35);
                        color: #516274;
                    }

                    &.accepted {
                        background: rgba(0, 103, 104, 0.14);
                        color: #006768;
                    }

                    &.invite {
                        background: rgba(0, 103, 104, 0.12);
                        color: #006768;
                    }
                }

                .respond-actions {
                    display: flex;
                    gap: 8px;
                    flex-shrink: 0;
                }

                .btn-accept,
                .btn-reject {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    min-height: 36px;
                    border-radius: 100px;
                    padding: 8px 16px;
                    font-size: 13px;
                    font-weight: 600;
                    letter-spacing: 0.1px;
                    cursor: pointer;
                    border: 1px solid transparent;
                    color: ${Variables.gray};

                    svg {
                        display: block;
                        flex-shrink: 0;
                        width: 16px;
                        height: 16px;
                        color: ${Variables.gray};
                        stroke: ${Variables.gray};
                    }
                }

                .btn-accept {
                    background: ${Variables.yellow};
                    border-color: ${Variables.yellow};
                    box-shadow: 0 6px 14px rgba(81, 98, 116, 0.16);

                    &:hover {
                        background: #e0b500;
                        border-color: #e0b500;
                    }
                }

                .btn-reject {
                    background: #FFF;
                    border-color: rgba(81, 98, 116, 0.45);

                    &:hover {
                        background: rgba(81, 98, 116, 0.08);
                    }
                }
            }
        }

        .footer {
            width: 100%;
            position: absolute;
            bottom: 28px;

            .btn-actions {
                display: flex;
            }
        }

        .new-initiatives {
            position: relative;
            top: 0px;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            padding: 24px;
            width: 100%;
            height: auto;
            background: #F1F2F4;
            border-radius: 20px;

            .text {
                display: flex;
                flex-direction: column;
                gap: 6px;
                letter-spacing: 0.1px;
                color: #49454F;
                margin-bottom: 21px;

                strong {
                    color: #1C1B1F;
                    font-size: 15px;
                }

                span {
                    font-size: 13px;
                    line-height: 1.4;
                }
            }

            .side-empty {
                font-size: 13px;
                color: #79747E;
                margin-bottom: 16px;
            }

            .initiatives-list {
                width: 100%;
                margin-bottom: 21px;
            }

            .initiatives-others {
                width: 100%;
                margin-bottom: 21px;

                .others-label {
                    font-size: 12px;
                    font-weight: 600;
                    color: #516274;
                    margin-bottom: 10px;
                    text-transform: uppercase;
                    letter-spacing: 0.04em;
                }
            }
        }
    }
}

.modal {
    &.new-account-modal {
        .modal-dialog {
            width: 412px;
            .modal-content {
                padding: 30px;
            }
        }
    }
}

@media (max-width: 991.98px) {
    .ui {
        &.form {
            .networks-layout {
                grid-template-columns: 1fr;
            }
        }
    }
}

@media (max-width: 575.99px) {
    .ui {
        &.form {
            .received-section {
                .received-card {
                    flex-direction: column;
                    align-items: flex-start;
                }
            }

            .new-initiatives {
                position: relative;
            }
        }
    }

    .modal {
        &.new-account-modal {
            .modal-dialog {
                width: 100%;
                margin: 0px;
                
                .modal-content {
                    padding: 20px;
                }
            }
        }
    }
}
`
